import React from "react";

/**
 * Hand-drawn 24px icon set for the portfolio.
 * One geometry, one stroke weight (1.6) so nothing looks bolted on
 * from a different library.
 */
const Icon = ({ size = 18, strokeWidth = 1.6, className = "", children, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
    focusable="false"
    {...rest}
  >
    {children}
  </svg>
);

export const ArrowRight = (props) => (
  <Icon {...props}>
    <path d="M4 12h15" />
    <path d="M13.5 6.5 19 12l-5.5 5.5" />
  </Icon>
);

export const ArrowUp = (props) => (
  <Icon {...props}>
    <path d="M12 20V5" />
    <path d="M6.5 10.5 12 5l5.5 5.5" />
  </Icon>
);

export const ArrowUpRight = (props) => (
  <Icon {...props}>
    <path d="M7 17 17 7" />
    <path d="M9 7h8v8" />
  </Icon>
);

export const Mail = (props) => (
  <Icon {...props}>
    <rect x="3" y="5" width="18" height="14" rx="1.5" />
    <path d="M3.7 6.4 12 12.6l8.3-6.2" />
  </Icon>
);

export const Download = (props) => (
  <Icon {...props}>
    <path d="M12 4v10.2" />
    <path d="M7.5 10 12 14.5 16.5 10" />
    <path d="M4.5 19.5h15" />
  </Icon>
);

export const Copy = (props) => (
  <Icon {...props}>
    <rect x="9" y="9" width="11" height="11" rx="1.5" />
    <path d="M15.5 5.5H6A1.5 1.5 0 0 0 4.5 7v9.5" />
  </Icon>
);

export const Check = (props) => (
  <Icon {...props}>
    <path d="M5 12.6l4.4 4.4L19 7.4" />
  </Icon>
);

export const MapPin = (props) => (
  <Icon {...props}>
    <path d="M12 21s6.4-5.6 6.4-10.2A6.4 6.4 0 0 0 5.6 10.8C5.6 15.4 12 21 12 21z" />
    <circle cx="12" cy="10.6" r="2.3" />
  </Icon>
);

export const Asterisk = (props) => (
  <Icon {...props}>
    <path d="M12 4.6v14.8" />
    <path d="M5.6 8.3l12.8 7.4" />
    <path d="M18.4 8.3L5.6 15.7" />
  </Icon>
);

export const CodeBrackets = (props) => (
  <Icon {...props}>
    <path d="M9.4 7 4.4 12l5 5" />
    <path d="M14.6 7l5 5-5 5" />
  </Icon>
);

export const Cube = (props) => (
  <Icon {...props}>
    <path d="M12 3l8.5 4.7v9.6L12 21.9 3.5 17.3V7.7z" />
    <path d="M3.5 7.7 12 12.4l8.5-4.7" />
    <path d="M12 12.4v9.4" />
  </Icon>
);

export const Calendar = (props) => (
  <Icon {...props}>
    <rect x="3.5" y="5" width="17" height="15" rx="1.5" />
    <path d="M3.5 10h17" />
    <path d="M8 3.5v3" />
    <path d="M16 3.5v3" />
  </Icon>
);

export const Menu = (props) => (
  <Icon {...props}>
    <path d="M4 7.5h16" />
    <path d="M4 12h16" />
    <path d="M4 16.5h9" />
  </Icon>
);

export const Close = (props) => (
  <Icon {...props}>
    <path d="M6 6l12 12" />
    <path d="M18 6L6 18" />
  </Icon>
);

export const Layers = (props) => (
  <Icon {...props}>
    <path d="M12 3.5l8.5 4.6-8.5 4.6-8.5-4.6z" />
    <path d="M3.5 13.2l8.5 4.6 8.5-4.6" />
  </Icon>
);

export const Send = (props) => (
  <Icon {...props}>
    <path d="M20.5 3.5 3.5 10.4l6.6 2.4 2.4 6.6z" />
    <path d="M20.5 3.5l-9.9 10.1" />
  </Icon>
);

export const Pulse = (props) => (
  <Icon {...props}>
    <path d="M3 13.5h3.4L9 8.2l3.4 8.8 2.6-6.1H21" />
  </Icon>
);

export const Sun = (props) => (
  <Icon {...props}>
    <circle cx="12" cy="12" r="4.1" />
    <path d="M12 2.8v2.2" />
    <path d="M12 19v2.2" />
    <path d="M2.8 12H5" />
    <path d="M19 12h2.2" />
    <path d="M5.5 5.5 7 7" />
    <path d="M17 17l1.5 1.5" />
    <path d="M18.5 5.5 17 7" />
    <path d="M7 17l-1.5 1.5" />
  </Icon>
);

export const Moon = (props) => (
  <Icon {...props}>
    <path d="M20.2 14.6A8.6 8.6 0 0 1 9.4 3.8a8.6 8.6 0 1 0 10.8 10.8z" />
  </Icon>
);

export const Replay = (props) => (
  <Icon {...props}>
    <path d="M19.8 12.4a7.8 7.8 0 1 1-2.4-5.7" />
    <path d="M19.8 4.6v5.2h-5.2" />
  </Icon>
);